// Central runtime configuration. Every URL can be overridden with a
// REACT_APP_* variable in .env / .env.local (Create React App convention).
const env = (key, fallback) => {
  const value = process.env[key];
  return value === undefined || value === "" ? fallback : value;
};

const config = {
  apiBaseUrl: env("REACT_APP_API_BASE_URL", "http://localhost:3000"),
  globalApiBaseUrl: env(
    "REACT_APP_GLOBAL_API_BASE_URL",
    "https://gui-backend.seekright.com",
  ),
  loginUrl: env(
    "REACT_APP_LOGIN_URL",
    "https://sr-backend-api.takeleap.in/Master/login",
  ),
  socketUrl: env("REACT_APP_SOCKET_URL", "http://localhost:10025"),
  socketUsername: env("REACT_APP_SOCKET_USERNAME", "frontend"),
  // Map metadata is served by the same backend unless overridden.
  metadataBaseUrl: env(
    "REACT_APP_METADATA_BASE_URL",
    env("REACT_APP_API_BASE_URL", "http://localhost:3000"),
  ),
  mapMaxGapMinutes: Number(env("REACT_APP_MAP_MAX_GAP_MINUTES", "120")) || 120,
  sendAuthHeader: env("REACT_APP_SEND_AUTH_HEADER", "false") === "true",
  siteAccessRole: "Site_access",
  toastDurationMs: 2000,
  videoNameMaxLength: 12,
};

export default config;
